import React, { useState } from "react";
import { navigate } from "gatsby";

import { HeaderDesign } from "@util/types";
import { SearchFieldWrapper } from "./searchField.style";
import { IconSearch } from "@util/assets";
import { useEventListener } from "@util/hooks";
import { Container } from "@util/standard";

interface Props {
  design?: HeaderDesign;
}

function SearchField({ design }: Props) {
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [isFocussed, setIsFocussed] = useState(false);

  const handleKeyUp = (e: KeyboardEvent) => {
    if (e.key === "Enter" && isFocussed) {
      handleSearch();
    }
    return;
  };

  const handleSearch = () => {
    if (inputSearchValue === "") return null;
    navigate(`/search-results?${encodeURI(inputSearchValue)}`);
    return;
  };

  useEventListener("keyup", handleKeyUp);

  return (
    <SearchFieldWrapper design={design} className="search-field">
      <input
        type="text"
        onFocus={() => setIsFocussed(true)}
        onBlur={() => setIsFocussed(false)}
        placeholder="Search"
        onChange={e => setInputSearchValue(e.target.value)}
      />
      <Container onClick={handleSearch} cursor="pointer">
        <IconSearch />
      </Container>
    </SearchFieldWrapper>
  );
}

export default SearchField;
